import { useState } from 'react';
import { useLettersForm } from '../provider/LettersFormContext';
import { CareMapprTextarea } from '../../../../../components/Inputs/textarea';
import { LetterType } from '../PharmacistDoctorLetterSection';
import SummaryRecommandation from './SummaryRecommandation';
import MedicationChanges from './MedicationChanges';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import { CareMapprTextField } from '../../../../../components/Inputs/textField';
import CaremapprConfirmation from '../../../../../components/Confirmation/CaremapprConfirmation';
import { useMedicationProfileDirty } from '../../../context/MedicationProfileDirtyProvider';

type PharmacyLetterFormProps = {
  onClose: () => void;
};

const PharmacyLetterForm = ({ onClose }: PharmacyLetterFormProps) => {
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);
  const {
    pharmacistLetterForm,
    commitPharmacistLetterState,
    resetPharmacistLetterToCommittedState,
  } = useLettersForm();
  const isDirty = pharmacistLetterForm.formState.isDirty;
  const values = pharmacistLetterForm.watch();
  const { setIsDirty } = useMedicationProfileDirty();
  return (
    <form className="letters-form-container">
      <div className="pharmacist-letters-form">
        <CareMapprTextField
          placeholder="Start typing..."
          label="Pharmacist name"
          value={values.pharmacistName || ''}
          onChange={(e) => {
            pharmacistLetterForm.setValue('pharmacistName', e.target.value, {
              shouldDirty: true,
            });
            setIsDirty(true);
          }}
        />

        <CareMapprTextarea
          autoResize
          placeholder="Start typing..."
          label="Introduction"
          rows={3}
          value={values.introduction || ''}
          onChange={(e) => {
            pharmacistLetterForm.setValue('introduction', e.target.value, {
              shouldDirty: true,
            });
            setIsDirty(true);
          }}
        />
        <MedicationChanges type={LetterType.PHARMACIST} />
        <SummaryRecommandation type={LetterType.PHARMACIST} />
        <div className="action-buttons">
          <CareMapprButton
            onClick={() => {
              if (isDirty) {
                setConfirmResetOpen(true);
              } else {
                onClose();
              }
            }}
            variant="link"
            type="button"
            style={{
              fontWeight: 'bold',
              color: 'black',
              fontSize: '14px',
              textDecoration: 'none',
            }}
          >
            Cancel & close
          </CareMapprButton>
          <CareMapprButton
            onClick={() => {
              commitPharmacistLetterState();
              setIsDirty(false);
              onClose();
            }}
            type="button"
            style={{
              fontWeight: 'bold',
              color: 'black',
              fontSize: '14px',
              textDecoration: 'none',
            }}
          >
            Save
          </CareMapprButton>
        </div>
      </div>
      <CaremapprConfirmation
        open={confirmResetOpen}
        text="Reset all fields will reset all input values"
        icon="warning"
        onConfirm={() => {
          resetPharmacistLetterToCommittedState();
          setIsDirty(false);
          onClose();
          setConfirmResetOpen(false);
        }}
        onClose={() => setConfirmResetOpen(false)}
        showCancelButton
      />
    </form>
  );
};

export default PharmacyLetterForm;
